function initPublicGallery() {
    const gallery = document.querySelector('[data-public-gallery]');
    const viewer = document.querySelector('[data-gallery-viewer]');
    if (!gallery || !viewer || typeof viewer.showModal !== 'function') return;

    const items = Array.from(gallery.querySelectorAll('[data-gallery-item]'));
    const image = viewer.querySelector('[data-gallery-viewer-image]');
    const caption = viewer.querySelector('[data-gallery-viewer-caption]');
    const counter = viewer.querySelector('[data-gallery-counter]');
    const closeButton = viewer.querySelector('[data-gallery-close]');
    const prevButton = viewer.querySelector('[data-gallery-prev]');
    const nextButton = viewer.querySelector('[data-gallery-next]');
    let currentIndex = 0;
    let trigger = null;

    if (items.length === 0 || !image || !caption || !counter) return;

    const render = index => {
        currentIndex = (index + items.length) % items.length;
        const item = items[currentIndex];
        image.src = item.href;
        image.alt = item.dataset.galleryAlt || '';
        caption.textContent = item.dataset.galleryCaption || '';
        counter.textContent = `${currentIndex + 1} / ${items.length}`;

        const nextItem = items[(currentIndex + 1) % items.length];
        if (nextItem && nextItem !== item) {
            const preload = new Image();
            preload.src = nextItem.href;
        }
    };

    const open = (item, index) => {
        trigger = item;
        render(index);
        viewer.showModal();
        closeButton?.focus();
    };

    items.forEach((item, index) => {
        item.addEventListener('click', event => {
            event.preventDefault();
            open(item, index);
        });
    });

    closeButton?.addEventListener('click', () => viewer.close());
    prevButton?.addEventListener('click', () => render(currentIndex - 1));
    nextButton?.addEventListener('click', () => render(currentIndex + 1));

    if (items.length < 2) {
        if (prevButton) prevButton.hidden = true;
        if (nextButton) nextButton.hidden = true;
    }

    viewer.addEventListener('click', event => {
        if (event.target === viewer) viewer.close();
    });

    viewer.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') {
            event.preventDefault();
            render(currentIndex - 1);
        } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            render(currentIndex + 1);
        }
    });

    viewer.addEventListener('close', () => {
        image.removeAttribute('src');
        trigger?.focus();
    });
}

document.addEventListener('DOMContentLoaded', initPublicGallery);
